import { useEffect, useState } from 'react';

export const useDelayedValue = <T>(delayedValue: T, ms: number) => {
    const [value, setValue] = useState<T | undefined>();

    useEffect(() => {
        const id = setTimeout(() => {
            setValue(delayedValue);
        }, ms);

        return () => clearTimeout(id);
    }, [delayedValue, ms]);

    return value;
};
